"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Rewards factory
 * formats the raw data into a usable format
 */
const get_1 = __importDefault(require("lodash/get"));
/**
 * Returns formatted rewards data
 * @param {string} reward
 * @returns {RewardType}
 */
function rewardFactory(reward) {
    return {
        provider: (0, get_1.default)(reward, 'provider'),
        customerIdentifier: (0, get_1.default)(reward, 'customerIdentifier', ''),
        value: (0, get_1.default)(reward, 'value', ''),
        valueType: (0, get_1.default)(reward, 'valueType'),
        status: (0, get_1.default)(reward, 'status', ''),
        rewardedOn: (0, get_1.default)(reward, 'rewardedOn', ''),
        netAmount: (0, get_1.default)(reward, 'netAmount', ''),
        estimatedAmount: (0, get_1.default)(reward, 'estimatedAmount', ''),
        rewardMultiplier: (0, get_1.default)(reward, 'rewardMultiplier'),
    };
}
exports.default = rewardFactory;
